// extracted by mini-css-extract-plugin
export var container = "Interview-module--container--0175c";
export var animation = "Interview-module--animation--9133f";
export var layout = "Interview-module--layout--e2726";
export var title = "Interview-module--title--80dce";
export var subtitle = "Interview-module--subtitle--f1825";
export var sliderWrapper = "Interview-module--sliderWrapper--a6ad5";
export var sliderControlsWrapper = "Interview-module--sliderControlsWrapper--4c27d";
export var sliderControls = "Interview-module--sliderControls--10977";